import React from 'react';
import Chart from 'react-apexcharts';
import { connect } from 'react-redux';
import ChartResultList from './ChartResultList';
const WifaResult = (props) => {
  const result = props?.report?.data?.[0];
  if (!result) {
    return null;
  }
  const {
    totalGirl,
    totalGirlPercentage,
    totalIntake,
    totalIntakePercentage,
    age10to14,
    age10to14Percentage,
    age15to19,
    age15to19Percentage,
    age10to14GirlIntake,
    age10to14GirlTotal,
    age15to19GirlIntake,
    age15to19GirlTotal,
    program,
    year,
    month,
    week,
    participatedTotal,
    class_name_en,
    section_name_en,
  } = result;
  const classLabel = props.GradeName || class_name_en;
  const sectionLabel = props.sectionName || section_name_en;
  const hasParticipation = Number(participatedTotal ?? totalIntake) > 0;

  // chart data
  const charData = {
    options: {
      colors: ['#FFC426', '#E3488A'],
      chart: {
        id: 'apexchart-example',
      },
      xaxis: {
        categories: ['10-14', '15-19'],
      },
      dataLabels: {
        style: {
          colors: ['#304758'],
        },
      },
      legend: {
        onItemHover: {
          highlightDataSeries: false,
        },
        onItemClick: {
          toggleDataSeries: false,
        },
      },
    },
    series: [
      {
        name: `total`, //boys
        data: [age10to14GirlTotal, age15to19GirlTotal],
      },
      {
        name: `intake`, //girls
        data: [age10to14GirlIntake, age15to19GirlIntake],
      },
    ],
  };
  return (
    <React.Fragment>
      <div className='container mx-auto'>
        <div className='flex flex-wrap flex-col  w-full px-4 sm:w-4/5 mx-auto'>
          <div className='border border-gray-300 w-full rounded p-10'>
            <div className='flex justify-between'>
              <div className='text-left'>
                <h1 className='mb-4 text-base font-semibold md:text-2xl md:font-bold capitalize'>
                  {classLabel ? ` ${classLabel} ` : ''}
                  {props.shiftName === undefined ? '' : ` ${props.shiftName} `}
                  {sectionLabel ? ` ${sectionLabel} ` : ''}
                </h1>
                <h1 className=' text-base text-black md:text-lg capitalize font-bold'>
                  <span className=' text-gray-500 font-semibold'>Program : </span>
                  <span>{props.title} </span>
                </h1>
                <h1 className=' text-base text-black md:text-lg capitalize font-bold'>
                  <span className=' text-gray-500 font-semibold'>Year : </span>
                  <span>{year}</span>
                </h1>
              </div>
              <div className=''>
                {/* <button type="button"
                                        className="w-full mb-4   py-2 px-6 capitalize text-[14px] lg:text-[18px] rounded text-white hover:text-white bg-gradient  hover_gradient ">
                                        <span > download report </span>
                                    </button> */}
                {month && (
                  <h1 className=' text-base text-black md:text-lg capitalize font-bold'>
                    <span className=' text-gray-500 font-semibold'>Month : </span>
                    <span>{month}</span>
                  </h1>
                )}
                {week && (
                  <h1 className=' text-base text-black md:text-lg capitalize font-bold'>
                    <span className=' text-gray-500 font-semibold'>Week : </span>
                    <span>{week}</span>
                  </h1>
                )}
              </div>
            </div>

            {!hasParticipation && (
              <p className='mb-4 text-center text-sm md:text-base text-amber-600 font-semibold'>
                No participation data for this class and section in the selected week.
              </p>
            )}

            <div id='bar_chart' className='w-full md:w-2/3 mx-auto'>
              <Chart options={charData.options} series={charData.series} type='bar' height={320} />
            </div>

            <ChartResultList title='total intake' totalNumber={totalIntake} percentage={totalIntakePercentage} />
            <ChartResultList title='10 - 14 Age' totalNumber={age10to14} percentage={age10to14Percentage} />
            <ChartResultList title='15 - 19 Age' totalNumber={age15to19} percentage={age15to19Percentage} />
            <ChartResultList title=' total girls' totalNumber={totalGirl} percentage={totalGirlPercentage} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    // check is shift yes or not
    hasShift: state.login?.currentUser,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    // getStudent: (studentInfo) => dispatch(sectionStudentAction(studentInfo)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WifaResult);
